
// 表示要素にナンバリング
$(function () {
	$('.c-tidle-table dl.in').each(function (i) {
		$(this).attr('id', 'in_' + (i + 1));
	});
});
